































import { Component, Prop, Vue } from "vue-property-decorator";
import MainDemo from "@/components/demo/main-demo.vue";
import RouteCitysDemo from "@/components/demo/route_info/route-citys-demo.vue";
import ChangeCityForm from "@/components/forms/route_info/change-city-form.vue";
import LanguagesButtons from "@/components/buttons/languages-buttons.vue";
import ButtonBack from "@/components/buttons/button-back.vue";

import { preferred_language } from "@/config/languags.config.json";
import { IRouteCity } from "@/@types/routeInfo/route-info";

@Component({
  components: {
    MainDemo,
    ButtonBack,
    LanguagesButtons,
    RouteCitysDemo,
    ChangeCityForm,
  },
})
export default class AddRouteCity extends Vue {
  @Prop({ type: String, default: "" }) id!: string;
  @Prop({ type: Array, default: () => [] }) cityList!: Array<IRouteCity>;
  locale = preferred_language;
  city: IRouteCity | null = null;

  updateDemo(city: IRouteCity): void {
    if (!this.city) {
      this.city = Object.assign({}, city);
      return;
    }
    this.$set(this.city, "name", Object.assign({}, city.name));
    this.$set(this.city, "description", Object.assign({}, city.description));
    this.$set(this.city, "address", Object.assign({}, city.address));
    this.$set(this.city, "excursion", Object.assign({}, city.excursion));
    this.city.image.name = city.image.name;
  }

  submitSendCity(city: IRouteCity): void {
    let data: any = {};
    if (this.id) {
      const obj = this.cityList.find((el) => el._id == this.id);
      if (!obj) {
        this.$notify({
          group: "global",
          text: String(this.$i18n.t("alerts.emptyUpdate")),
          type: "warn",
        });
        return;
      }

      for (const key of Object.keys(city)) {
        if (
          obj[key as keyof IRouteCity] != city[key as keyof IRouteCity] &&
          city[key as keyof IRouteCity] != undefined
        )
          data[key] = city[key as keyof IRouteCity];
      }
    } else data = city;
    this.$emit("changeCity", this.id, data);
    this.$router.push({ name: "RouteList" });
  }

  mounted(): void {
    if (this.id) {
      const city = this.cityList.find((el) => el._id == this.id);
      if (city) this.city = Object.assign({}, city);
    }
  }
}
